import { useRouter } from '@application/utils';
import { Button } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import * as RootStyled from '../../styled';
import * as Styled from './styled';

export const SeriousSection: FC = () => {
  const { translate } = useTranslation();
  const { routeLocationDescriptor } = useRouter();

  return (
    <Styled.Wrapper>
      <Styled.Content>
        <RootStyled.Title color="purple">
          {translate('breederLanding.serious.title')}
        </RootStyled.Title>
        <p>{translate('breederLanding.serious.text')}</p>
        <Button color="blue" shrink size="large" link={routeLocationDescriptor('joinBreeder')}>
          {translate('common.buttons.registerAsBreeder')}
        </Button>
      </Styled.Content>
    </Styled.Wrapper>
  );
};
